module.exports = __webpack_public_path__ + "img/479-c445df.png";